import React from "react";
import ConfigParser from '../../../js/common/utility/configParser';
import Element from '../../basic/element';
import ListPanel from './components/listPanel';
import Item from './item';
import ItemDetail from './itemDetail';
import { checkActiveTab } from "./utli";
import axios from "axios";
import './index.scss';

export default class LearningPath extends React.Component {
    constructor(props) {
        super(props);

        //Creating config file from parsing xml file
        const {config} = this.props;
        const parser = ConfigParser.toParser(config);
        const cfg = {
            props: ConfigParser.parseRoot(config, 'pubhub-learning-path'),
            title: parser.parseObject('> title', ''),
            description: parser.parseObject('> description', ''),
            srcUrl: parser.parseString('srcUrl', ''),
            srcBaseUrl: parser.parseString('srcBaseUrl', PubHub.APIHost),
            statusApiUrl: parser.parseString('statusApiUrl', ''),
            profileId: parser.parseString('profileId', ''),
            entry: {
                sessionsText: parser.parseString('entry sessions', 'sessions'),
                sessionText: parser.parseString('entry session', 'session'),
                labsText: parser.parseString('entry labs', 'labs'),
                labText: parser.parseString('entry labs', 'lab'),
            },
            columns: {
                xl: parser.parseNumber('columns xl', 2),
                lg: parser.parseNumber('columns lg', 2),
                md: parser.parseNumber('columns md', 2),
                sm: parser.parseNumber('columns sm', 1),
                xs: parser.parseNumber('columns xs', 1)
            },
            autoScroll: {
                enabled: parser.parseBool('autoScroll enabled', true),
                duration: parser.parseNumber('autoScroll duration', 200),
                offset: parser.parseNumber('autoScroll offset', 26),
            },
            autoRefreshTimer: parser.parseNumber('autoRefresh Frequency', 30),
            pathType: parser.parseString('pathType', ""),
            enableHashjump: parser.parseBool('enableHashJump', true)
        };


        //Default initial state, assigning config file to state
        this.state = {
            config: cfg,
            data: null,
            openIndex: -1,
            loading: false
        };


        //Ajax call handlers
        this.statusRefreshTimer = null;
        this.fetchPathData = this.fetchPathData.bind(this);
        this.fetchPathStatus = this.fetchPathStatus.bind(this);
        this.handleResync = this.handleResync.bind(this);
        this.handleHashJump = this.handleHashJump.bind(this);

    }


    componentDidMount() {
        //Assign custom event listener when the page first loaded
        const self = this;
        window.addEventListener('manual-resync', self.handleResync);


        //Resuming protected content when clicked without logged in
        PlatformSDK.resumeProtectedData(function (redirectUrl) {

            // If there was some protected link before, we will do the redirect after the social login is completed
            if (redirectUrl) {
                window.open(redirectUrl, '_blank', 'noopener,noreferrer');
            }
        });

        //Fetch path data
        this.fetchPathData();


        //If the current tab is active and the user is logged in, fetch path status
        checkActiveTab(() => {
            if (checkActiveTab() && window.PlatformSDK.isLoggedIn()) {
                this.fetchPathStatus(this.state.data);
            }
        });

        //Set a timer based off of config (default is 30s if no input is provided) to refresh the user status periodically
        this.statusRefreshTimer = setInterval(function () {
            //If the current tab is active and the user is logged in, fetch path status
            if (checkActiveTab() && window.PlatformSDK.isLoggedIn()) {
                self.fetchPathStatus(self.state.data);

            }
        }, this.state.config.autoRefreshTimer * 1000)
    }


    //Un-register the custom event listener and clear the timer when the page get dismounted
    componentWillUnmount() {
        const self = this;
        window.removeEventListener('manual-resync', self.handleResync);
        // use intervalId from the state to clear the interval
        clearInterval(this.statusRefreshTimer);
    }


    //Render spinning wheel
    renderLoading() {
        return (
            <div className='loading-container'>
                <div className='pubhub-loading'></div>
            </div>
        );
    }

    //Render list of paths
    renderItems(data, openIndex, columns, entry) {
        const items = data.map((data, index) => this.renderItem(index, openIndex, data, entry));
        const detail = this.renderItemDetail(data, openIndex);

        return (
            <ListPanel index={openIndex} detail={detail} columns={columns}>
                {items}
            </ListPanel>
        );
    }

    //Render each path item
    renderItem(index, openIndex, data, entry) {
        return (
            <Item
                {...entry}
                key={index}
                index={index}
                selected={openIndex == index}
                data={data}
                onClick={this.onClickItem}/>
        );
    }

    //Render detail view of each path item
    renderItemDetail(data, index) {
        if (index == -1) return null;

        return (
            (<ItemDetail data={data[index]} onClose={() => {
                this.onTurnItem(index)
            }}/>)
        );
    }


    //Click handler of each path item
    onClickItem = (e) => {
        if (this.state.config.enableHashjump) {
            location.hash = "#" + e.currentTarget.id;
        }


        const index = parseInt(e.currentTarget.dataset.index);
        this.onTurnItem(index);

        const {enabled, duration, offset} = this.state.config.autoScroll;
        if (enabled && index != this.state.openIndex) {
            PubHub.util.scrollTo(e.currentTarget, duration, offset);
        }
    }


    //Log current opened item since only 1 detail view is allowed at any given time
    onTurnItem = (index) => {
        let openIndex = index;

        if (index == this.state.openIndex) {
            openIndex = -1;
            history.pushState("", document.title, window.location.pathname + window.location.search);
        }

        this.setState({openIndex});
    };

    buildUrl(apiName) {
        let isNotProduction = (window.PubHub.env === 'test' || window.PubHub.env === 'staging');
        let urlParams = isNotProduction ? ("/" + this.state.config.profileId) : "";
        if (apiName === "pathfulls") {
            urlParams = '';
            if (this.state.config.pathType !== '') {
                urlParams = urlParams + `?Type=${this.state.config.pathType}`
            } else {
                urlParams = urlParams + `?Type=devnet.path`

            }

        }
        return `${this.state.config.srcBaseUrl}/v1/devnetpath/${apiName}` + urlParams;
    }

    fetchPathData() {
        const srcUrl = this.buildUrl('pathfulls');
        axios({
            method: 'get',
            url: srcUrl,
            withCredentials: true
        }).then((response) => {
            const data = response.data;
            data.forEach(path => {
                path.sessionCount = path.CollectionsFull.length;
                path.labCount = path.CollectionsFull.reduce((sum, i) => sum + (i.TasksFull ? i.TasksFull.length : 0), 0);
            });
            this.setState({data}, () => {
                if (this.state.config.enableHashjump) {
                    this.handleHashJump();
                }

                if (window.PlatformSDK.isLoggedIn() === true) {
                    this.fetchPathStatus(this.state.data);
                }
            });
        });
    }


    handleHashJump() {
        if (location.hash !== "") {
            let jumpLocation = location.hash.replace("#", "");
            let dataIndex = this.state.data.findIndex((element) => {
                let pathId = element.id;
                return pathId.toLowerCase() === jumpLocation;
            });

            this.setState({
                openIndex: dataIndex
            }, () => {
                PubHub.util.scrollTo(document.getElementById(jumpLocation), 800, 28);
            })
        }
    }

    fetchPathStatus(data) {
        const statusApiUrl = this.buildUrl('userpathstatus');
        axios({
            method: 'get',
            url: statusApiUrl,
            withCredentials: true
        }).then((res) => {
            const pathsStatus = res.data.PathsStatus;
            const collectionsStatus = res.data.CollectionsStatus;
            data.forEach(path => {
                path.progress = pathsStatus[path.id] ? pathsStatus[path.id].percentComplete : 0;
                path.CollectionsFull.forEach(i => {
                    const completedTasks = collectionsStatus[i.id] ? (collectionsStatus[i.id].completedTasks || {}) : {};
                    i.TasksFull.forEach(t => {
                        t.completed = completedTasks[t.id] ? completedTasks[t.id] : false;
                    })
                });
            });
            this.setState({data});
        })
    }

    handleResync() {
        const resyncUrl = this.buildUrl('userpathstatus/resync');
        this.setState({loading: true});

        axios({
            method: 'put',
            url: resyncUrl,
            withCredentials: true,
            data: {"force": true}
        }).then((res) => {
            if (res.status == 200) {
                const pathsStatus = res.data.PathsStatus;
                const collectionsStatus = res.data.CollectionsStatus;
                const data = this.state.data;
                data.forEach(path => {
                    path.progress = pathsStatus[path.id] ? pathsStatus[path.id].percentComplete : 0;
                    path.CollectionsFull.forEach(i => {
                        const completedTasks = collectionsStatus[i.id] ? (collectionsStatus[i.id].completedTasks || {}) : {};
                        i.TasksFull.forEach(t => {
                            t.completed = completedTasks[t.id] ? completedTasks[t.id] : false;
                        })
                    });
                });
                this.setState({data: data, loading: false}, () => {
                });
            }
        }).catch((thrown) => {
            this.setState({
                loading: false
            })
        });

    }

    render() {
        const {config, data, openIndex} = this.state;

        const content = data ? this.renderItems(data, openIndex, config.columns, config.entry) : this.renderLoading();

        return (
            <div {...config.props}>
                <div className='header'>
                    <div className='container'>
                        <Element className='title' data={config.title}/>
                        <Element className='description' data={config.description}/>
                        <div className={"resync"} onClick={this.handleResync}>
                            <svg width="28px" height="30px" viewBox="0 0 28 30" version="1.1">
                                <title>Refresh button</title>
                                <desc>for Get Started page</desc>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="StartNow-011119-Copy" transform="translate(-1362.000000, -670.000000)"
                                       fill="#BFBFBF" fillRule="nonzero">
                                        <path
                                            d="M1382.60554,673.267296 L1381.14038,675.924081 C1379.62195,675.133509 1377.89836,674.687024 1376.07125,674.687024 C1369.9652,674.687024 1365.01527,679.673546 1365.01527,685.824733 C1365.01527,691.975921 1369.9652,696.962443 1376.07125,696.962443 C1381.49083,696.962443 1385.99963,693.034108 1386.94493,687.849772 L1390,687.849772 C1389.0246,694.719296 1383.16009,700 1376.07125,700 C1368.29991,700 1362,693.653517 1362,685.824733 C1362,677.99595 1368.29991,671.649467 1376.07125,671.649467 C1378.42989,671.649467 1380.65298,672.234073 1382.60554,673.267296 Z M1388.23712,679.672401 L1377.82117,679.123477 L1384.16262,670 L1388.23712,679.672401 Z"
                                            id="Combined-Shape-Copy"></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                {/* Determine whether to show the spinning wheel by state change */}
                {this.state.loading ? this.renderLoading() : content}
            </div>
        );
    }
}
